import { useState } from "react";
import { ArrowRight, Menu, X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/logo-color-white.png";

const navLinks = [
  { href: "#product", label: "Product" },
  { href: "#workflow", label: "Workflow" },
  { href: "#security", label: "Security" },
];

const HomeNavBar = ({ hideLinks = false }) => {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navigateTo = (path) => {
    setIsMenuOpen(false);
    navigate(path);
  };

  return (
    <nav className="mx-auto max-w-7xl rounded-3xl border border-white/15 bg-slate-950/65 px-4 py-3 shadow-modal backdrop-blur md:px-6">
      <div className="flex items-center justify-between gap-4">
        <a href="https://wiseup.africa" className="flex shrink-0 items-center">
          <img src={logo} alt="WiseApp logo" className="h-10 w-auto sm:h-12" />
        </a>

        {!hideLinks && (
          <div className="hidden items-center gap-8 md:flex">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="type-label text-white/75 transition-colors duration-200 hover:text-secondary"
              >
                {link.label}
              </a>
            ))}
          </div>
        )}

        <div className="hidden items-center gap-3 md:flex">
          <button
            onClick={() => navigateTo("/sign-in")}
            className="rounded-full border border-white/20 px-5 py-2.5 text-sm font-medium text-white transition-colors duration-200 hover:border-secondary hover:text-secondary"
          >
            Sign in
          </button>
          <button
            onClick={() => navigateTo("/sign-up")}
            className="inline-flex items-center gap-2 rounded-full bg-secondary px-5 py-2.5 text-sm font-semibold text-primary transition-transform duration-200 hover:-translate-y-0.5 hover:bg-white"
          >
            Sign up
            {/* <ArrowRight className="h-4 w-4" /> */}
          </button>
        </div>

        <button
          type="button"
          onClick={() => setIsMenuOpen((current) => !current)}
          className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-white transition-colors duration-200 hover:border-secondary hover:text-secondary md:hidden"
          aria-label={isMenuOpen ? "Close navigation menu" : "Open navigation menu"}
        >
          {isMenuOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {isMenuOpen && (
        <div className="mt-4 rounded-3xl border border-white/10 bg-white/5 p-4 md:hidden">
          {!hideLinks && (
            <div className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="rounded-2xl px-3 py-2 text-sm font-medium text-white/80 transition-colors duration-200 hover:bg-white/5 hover:text-secondary"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {link.label}
                </a>
              ))}
            </div>
          )}

          <div className={`grid gap-3 ${!hideLinks ? "mt-4" : ""}`}>
            <button
              onClick={() => navigateTo("/sign-in")}
              className="rounded-full border border-white/15 px-4 py-3 text-sm font-medium text-white transition-colors duration-200 hover:border-secondary hover:text-secondary"
            >
              Sign in
            </button>
            <button
              onClick={() => navigateTo("/sign-up")}
              className="inline-flex items-center justify-center gap-2 rounded-full bg-secondary px-4 py-3 text-sm font-semibold text-primary transition-transform duration-200 hover:-translate-y-0.5 hover:bg-white"
            >
              Get started
              <ArrowRight className="h-4 w-4" />
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default HomeNavBar;
